import React from 'react';

export const disableFileField = (condition: boolean) => {
  return condition
    ? (event: React.MouseEvent<HTMLElement, MouseEvent>) =>
        event.stopPropagation()
    : undefined;
};
